<router-outlet></router-outlet>

<bc-circle-loading
  [text]="circleLoadingText"
  [accessibilityLabel]="circleLoadingAriaLabel"
  [speedLoader]="loaderSpeed"
>
</bc-circle-loading>

